module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Nicholson left international finance at the age of 46 with enough money to start travelling the world for fun. He published his first book in 2017, "), _c('em', [_vm._v("Mr Tambourine Man,")]), _vm._v(" written from his dreams detailing his adventures. He then went on to write two novels, "), _c('em', [_vm._v("The Tell-tale and My Back Pages.")]), _vm._v(" He has lived happily in Cornwall for the last twenty-three years with his loving wife of 42 years, Chrissie, and has a 33-year-old daughter, Lauren, whom he adores.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0